import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ButtonType } from '@shared/components/button/button.component';
import { LocaleService } from '@shared/services/locale.service';
import { ViewportService } from '@shared/services/viewport.service';

@Component({
	selector: 'app-company-pages',
	templateUrl: './company-pages.component.html',
	styleUrls: ['./company-pages.component.scss'],
})
export class CompanyPagesComponent implements OnInit {
	pageData: any;
	readonly buttonType = ButtonType;
	constructor(private route: ActivatedRoute, public locale: LocaleService, public viewport: ViewportService) {}

	openPdf(pdfLink: string): void {
		window.open(pdfLink, '_blank');
	}

	ngOnInit(): void {
		this.pageData = this.route.snapshot.data;
	}
}
